import { Domino } from "../models/domino_models";

export const BAREMO = [
  {
    value: 0,
    percentil: 5
  },
  {
    value: 12,
    percentil: 5
  },
  {
    value: 17,
    percentil: 10
  },
  {
    value: 23,
    percentil: 25
  },
  {
    value: 29,
    percentil: 50
  },
  {
    value: 34,
    percentil: 75
  },
  {
    value: 37,
    percentil: 90
  },
  {
    value: 40,
    percentil: 95
  },
  {
    value: 50,
    percentil: 95
  },
]

export const DOMINO_TEST_DATA: Domino[] = [
  {
    title: 't1',
    imageUrl: 'assets/images/domino/t1.png',
    correctValues: ['1', '3'],
    index: 1
  },
  {
    title: 't2',
    imageUrl: 'assets/images/domino/t2.png',
    correctValues: ['5', '2'],
    index: 2
  },
  {
    title: 't3',
    imageUrl: 'assets/images/domino/t3.png',
    correctValues: ['1', '2'],
    index: 3
  },
  {
    title: 't4',
    imageUrl: 'assets/images/domino/t4.png',
    correctValues: ['5', '4'],
    index: 4
  }
]

export const DOMINO_DATA: Domino[] = [
  {
    title: '1',
    imageUrl: 'assets/images/domino/1.png',
    correctValues: ['2', '4'],
    index: 1
  },
  {
    title: '2',
    imageUrl: 'assets/images/domino/2.png',
    correctValues: ['6', '1'],
    index: 2
  },
  {
    title: '3',
    imageUrl: 'assets/images/domino/3.png',
    correctValues: ['3', '5'],
    index: 3
  },
  {
    title: '4',
    imageUrl: 'assets/images/domino/4.png',
    correctValues: ['0', '2'],
    index: 4
  },
  {
    title: '5',
    imageUrl: 'assets/images/domino/5.png',
    correctValues: ['4', '1'],
    index: 5
  },
  {
    title: '6',
    imageUrl: 'assets/images/domino/6.png',
    correctValues: ['3', '6'],
    index: 6
  },
  {
    title: '7',
    imageUrl: 'assets/images/domino/7.png',
    correctValues: ['5', '2'],
    index: 7
  },
  {
    title: '8',
    imageUrl: 'assets/images/domino/8.png',
    correctValues: ['0', '4'],
    index: 8
  },
  {
    title: '9',
    imageUrl: 'assets/images/domino/9.png',
    correctValues: ['2', '6'],
    index: 9
  },
  {
    title: '10',
    imageUrl: 'assets/images/domino/10.png',
    correctValues: ['3', '3'],
    index: 10
  },
  {
    title: '11',
    imageUrl: 'assets/images/domino/11.png',
    correctValues: ['4', '0'],
    index: 11
  },
  {
    title: '12',
    imageUrl: 'assets/images/domino/12.png',
    correctValues: ['5', '1'],
    index: 12
  },
  {
    title: '13',
    imageUrl: 'assets/images/domino/13.png',
    correctValues: ['2', '3'],
    index: 13
  },
  {
    title: '14',
    imageUrl: 'assets/images/domino/14.png',
    correctValues: ['5', '6'],
    index: 14
  },
  {
    title: '15',
    imageUrl: 'assets/images/domino/15.png',
    correctValues: ['1', '4'],
    index: 15
  },
  {
    title: '16',
    imageUrl: 'assets/images/domino/16.png',
    correctValues: ['2', '5'],
    index: 16
  },
  {
    title: '17',
    imageUrl: 'assets/images/domino/17.png',
    correctValues: ['6', '0'],
    index: 17
  },
  {
    title: '18',
    imageUrl: 'assets/images/domino/18.png',
    correctValues: ['5', '1'],
    index: 18
  },
  {
    title: '19',
    imageUrl: 'assets/images/domino/19.png',
    correctValues: ['2', '2'],
    index: 19
  },
  {
    title: '20',
    imageUrl: 'assets/images/domino/20.png',
    correctValues: ['1', '5'],
    index: 20
  },
  {
    title: '21',
    imageUrl: 'assets/images/domino/21.png',
    correctValues: ['0', '4'],
    index: 21
  },
  {
    title: '22',
    imageUrl: 'assets/images/domino/22.png',
    correctValues: ['6', '3'],
    index: 22
  },
  {
    title: '23',
    imageUrl: 'assets/images/domino/23.png',
    correctValues: ['2', '1'],
    index: 23
  },
  {
    title: '24',
    imageUrl: 'assets/images/domino/24.png',
    correctValues: ['3', '5'],
    index: 24
  },
  {
    title: '25',
    imageUrl: 'assets/images/domino/25.png',
    correctValues: ['6', '4'],
    index: 25
  },
  {
    title: '26',
    imageUrl: 'assets/images/domino/26.png',
    correctValues: ['3', '0'],
    index: 26
  },
  {
    title: '27',
    imageUrl: 'assets/images/domino/27.png',
    correctValues: ['1', '5'],
    index: 27
  },
  {
    title: '28',
    imageUrl: 'assets/images/domino/28.png',
    correctValues: ['2', '4'],
    index: 28
  },
  {
    title: '29',
    imageUrl: 'assets/images/domino/29.png',
    correctValues: ['5', '5'],
    index: 29
  },
  {
    title: '30',
    imageUrl: 'assets/images/domino/30.png',
    correctValues: ['3', '6'],
    index: 30
  },
  {
    title: '31',
    imageUrl: 'assets/images/domino/31.png',
    correctValues: ['5', '6'],
    index: 31
  },
  {
    title: '32',
    imageUrl: 'assets/images/domino/32.png',
    correctValues: ['4', '0'],
    index: 32
  },
  {
    title: '33',
    imageUrl: 'assets/images/domino/33.png',
    correctValues: ['4', '4'],
    index: 33
  },
  {
    title: '34',
    imageUrl: 'assets/images/domino/34.png',
    correctValues: ['1', '0'],
    index: 34
  },
  {
    title: '35',
    imageUrl: 'assets/images/domino/35.png',
    correctValues: ['6', '2'],
    index: 35
  },
  {
    title: '36',
    imageUrl: 'assets/images/domino/36.png',
    correctValues: ['3', '5'],
    index: 36
  },
  {
    title: '37',
    imageUrl: 'assets/images/domino/37.png',
    correctValues: ['6', '0'],
    index: 37
  },
  {
    title: '38',
    imageUrl: 'assets/images/domino/38.png',
    correctValues: ['4', '6'],
    index: 38
  },
  {
    title: '39',
    imageUrl: 'assets/images/domino/39.png',
    correctValues: ['3', '5'],
    index: 39
  },
  {
    title: '40',
    imageUrl: 'assets/images/domino/40.png',
    correctValues: ['2', '1'],
    index: 40
  },
  {
    title: '41',
    imageUrl: 'assets/images/domino/41.png',
    correctValues: ['5', '1'],
    index: 41
  },
  {
    title: '42',
    imageUrl: 'assets/images/domino/42.png',
    correctValues: ['0', '6'],
    index: 42
  },
  {
    title: '43',
    imageUrl: 'assets/images/domino/43.png',
    correctValues: ['4', '6'],
    index: 43
  },
  {
    title: '44',
    imageUrl: 'assets/images/domino/44.png',
    correctValues: ['3', '0'],
    index: 44
  },
  {
    title: '45',
    imageUrl: 'assets/images/domino/45.png',
    correctValues: ['2', '5'],
    index: 45
  },
  {
    title: '46',
    imageUrl: 'assets/images/domino/46.png',
    correctValues: ['5', '6'],
    index: 46
  },
  {
    title: '47',
    imageUrl: 'assets/images/domino/47.png',
    correctValues: ['2', '2'],
    index: 47
  },
  {
    title: '48',
    imageUrl: 'assets/images/domino/48.png',
    correctValues: ['1', '3'],
    index: 48
  },
]
